import React from 'react';
import { __, __n } from 'i18n-for-browser';
import { calculateSavingsAndLoans } from './calculationsHelper';
import Defines from '../Defines';
import { groupIcons } from "../assets/assets";

function getOverviewData(props) {
  const { gameStateInput, gameState, project } = props;
  const showPolicyChoices = project && project.minPolicyChoices > 0;
  const bankEnabled = project && project.bankEnabled !== false;
  const { totalGameStateSum } = gameState;

  //Create a boolean to use for distinguishing Pro and Basic.
  const isPro = (gameStateInput.myState.niveau === "Pro" ? true : false);

  const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);

  //Accumilator for budgetchoices globa's
  let budgetChoicesTotal = 0;

  //Map through ministries to get each budget choice
  const budgetDistribution = gameStateInput.myState.ministerieGlobaVerdeling;
  const budgetChoices = Defines[gameState.difficulty.toLowerCase()].ministries.map(min => {
    //Add value to accumilator
    const value = (budgetDistribution[min] ? budgetDistribution[min] : 0);
    budgetChoicesTotal += value;

    //If choice contains collaboration, map through to generate images required.
    const images = (budgetDistribution[`${min}SW`] ?
      budgetDistribution[`${min}SW`].map((c) => (
        <img key={__(c)} src={groupIcons[__(c).toLowerCase()]} alt={__(c)} />
      ))
      : "");

    //Return an element
    return (<div key={__(min)} className="result-row">
      <div className="result-title">{__(min)}</div>
      <div className="right result-value">
        <div className="collaboration">{images}</div>
        <div className="value">{value}</div>
      </div>
    </div>);
  });

  //Accumilator for globa's spent on policies
  let policyTotal = 0;

  //Map through policychoices
  const policyKeys = Object.keys(gameStateInput.myState.policyChoices);
  const policyChoices = policyKeys.map((key) => {
    const current = gameStateInput.myState.policyChoices[key];

    /**
     * Custom basic quick fix
     */
    if (!isPro) {
      const choice = props.policyChoice.find(pc => pc.omschrijving === current || pc.Omschrijving === current);
      if (!choice) return false;
      policyTotal += choice.kosten_globas;
      return (
        <div key={current.title} className="result-row">
          <div className="result-title">{choice[`titel_oplossing_${props.gameState.language.toUpperCase()}`]}</div>
          <div className="right result-value">
            <div className="value">{choice.kosten_globas}</div>
          </div>
        </div>
      );
    }

    //Confirm the policy has been selected
    if (current.selected !== true) return false;

    //Add policy cost to accumilator
    policyTotal += current.globas;

    //If difficulty is pro, stop.
    if (isPro) return false;

    //Check if policy is a collaboration, then add the images.
    const images = (current.collaboration.length > 0 ?
      current.collaboration.map((c) => (
        <img key={__(c)} src={groupIcons[__(c).toLowerCase()]} alt={__(c)} />
      ))
      : "");

    //Return a row to display in the overview.
    return (
      <div key={current.title} className="result-row">
        <div className="result-title">{current.title}</div>
        <div className="right result-value">
          <div className="collaboration">{images}</div>
          <div className="value">{current.globas}</div>
        </div>
      </div>
    )
  }, 0);

  //Create sum of total spent money
  const totalSpent = policyTotal + budgetChoicesTotal;
  //Calculate remaining accordingly
  const remaining = totalGameStateSum.globas - totalSpent + savingsAndLoans;

  //Is put in a separate variable because it's in a different position on different levels.
  const sectionBeleidskeuzes = (
    <div className="result-group">
      <div className="title-bar">
        <div className="left title">{__n('sim_beleidskeuze', 0)}</div>
        <div className="right">{policyTotal}</div>
      </div>
      {policyChoices}
    </div>
  );

  //Construct final component.
  return (
    <div key="ovv" className="popup-overview">
      <div className="title-bar">
        <div className="left title"><h3>{__('sim_overzicht_verdeling')}</h3></div>
      </div>

      <div className="result-group">
        <div className="title-bar">
          <div className="left title">{__("sim_budget")}</div>
          <div className="right">{totalGameStateSum.globas + (bankEnabled ? savingsAndLoans : 0)}</div>
        </div>
        <div className="result-row">
          <div className="result-title">{isPro ? __("sim_overheidsinkomsten") : __("sim_belastingen")}</div>
          <div className="right result-value">{totalGameStateSum.globas}</div>
        </div>
        {bankEnabled ? (
          <div className="result-row">
            <div className="result-title">{isPro ? __("sim_saldo_sparen_lenen") : __("sim_basic_saldo_sparen_lenen")}</div>
            <div className="result-value">{(savingsAndLoans >= 0 ? "(+)" : "(-)")} {(savingsAndLoans >= 0 ? savingsAndLoans : savingsAndLoans * -1)}</div>
          </div>
        ) : null}
      </div>

      {isPro ? null : (showPolicyChoices ? sectionBeleidskeuzes : null)}

      <div className="result-group">
        <div className="title-bar">
          <div className="left title">{__n('sim_budgetkeuze', 0)}</div>
          <div className="right">{budgetChoicesTotal}</div>
        </div>
        {budgetChoices}
      </div>

      {isPro ? sectionBeleidskeuzes : null}

      <div className="result-group">
        <div className="title-bar">
          <div className="left title">{isPro ? __("sim_resterend_budget") : __("sim_basic_resterend_budget")}</div>
          <div className="right">{remaining}</div>
        </div>
      </div>

    </div>
  )
}

export {
  getOverviewData,
}



// WEBPACK FOOTER //
// ./src/helpers/ministriesHelper.js